
import Vue from "vue";
import AssistHistoryCard from "@/components/atoms/AssistHistoryCard.vue";
import { HistoryItem } from "@/store/modules/assistHistory";

// HTMLタグ除去
function stripHtmlTags(html: string): string {
  if (!html) return "";
  const doc = new window.DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
}

export default Vue.extend({
  name: "HistoryListContent",
  components: {
    AssistHistoryCard,
  },
  computed: {
    historyList(): HistoryItem[] {
      return this.$store.getters["assistHistory/filteredHistoryList"];
    },
    // プレビュー用にHTMLタグを除去したfeedbackPreviewを返すリスト
    displayHistoryList(): any[] {
      return this.historyList.map((history) => {
        let preview = history.feedbackPreview;
        // MATCHING_COMPANYとGENERATE_CATCHCOPYの場合はHTMLタグを除去
        const htmlFunctionTypes = ["MATCHING_COMPANY", "GENERATE_CATCHCOPY"];
        if (htmlFunctionTypes.includes(history.functionType) && preview && /<\/?[a-z][\s\S]*>/i.test(preview)) {
          preview = stripHtmlTags(preview);
        }
        return { ...history, feedbackPreview: preview };
      });
    },
  },
  async mounted() {
    console.log("HistoryListContent: mounted - fetching history data");
    await this.$store.dispatch("assistHistory/fetchHistoryList");

    // 🆕 ポーリング開始
    await this.$store.dispatch("assistHistory/startPolling");
  },
  async beforeDestroy() {
    // 🆕 ポーリング停止（メモリリーク防止）
    console.log("HistoryListContent: beforeDestroy - stopping polling");
    await this.$store.dispatch("assistHistory/stopPolling");
  },
  methods: {
    async handleRetry(): Promise<void> {
      console.log("HistoryListContent: retry button clicked");
      await this.$store.dispatch("assistHistory/refreshHistoryList");
    },
  },
});
